/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LeaderboardCompetitionResponse } from './LeaderboardCompetitionResponse';
import {
    LeaderboardCompetitionResponseFromJSON,
    LeaderboardCompetitionResponseFromJSONTyped,
    LeaderboardCompetitionResponseToJSON,
    LeaderboardCompetitionResponseToJSONTyped,
} from './LeaderboardCompetitionResponse';

/**
 * 
 * @export
 * @interface GetLeaderboardCompetitionsRecentlyCompletedResponse
 */
export interface GetLeaderboardCompetitionsRecentlyCompletedResponse {
    /**
     * 
     * @type {Array<LeaderboardCompetitionResponse>}
     * @memberof GetLeaderboardCompetitionsRecentlyCompletedResponse
     */
    leaderboards: Array<LeaderboardCompetitionResponse>;
    /**
     * 
     * @type {number}
     * @memberof GetLeaderboardCompetitionsRecentlyCompletedResponse
     */
    daysBack: number;
}

/**
 * Check if a given object implements the GetLeaderboardCompetitionsRecentlyCompletedResponse interface.
 */
export function instanceOfGetLeaderboardCompetitionsRecentlyCompletedResponse(value: object): value is GetLeaderboardCompetitionsRecentlyCompletedResponse {
    if (!('leaderboards' in value) || value['leaderboards'] === undefined) return false;
    if (!('daysBack' in value) || value['daysBack'] === undefined) return false;
    return true;
}

export function GetLeaderboardCompetitionsRecentlyCompletedResponseFromJSON(json: any): GetLeaderboardCompetitionsRecentlyCompletedResponse {
    return GetLeaderboardCompetitionsRecentlyCompletedResponseFromJSONTyped(json, false);
}

export function GetLeaderboardCompetitionsRecentlyCompletedResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetLeaderboardCompetitionsRecentlyCompletedResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'leaderboards': ((json['leaderboards'] as Array<any>).map(LeaderboardCompetitionResponseFromJSON)),
        'daysBack': json['daysBack'],
    };
}

export function GetLeaderboardCompetitionsRecentlyCompletedResponseToJSON(json: any): GetLeaderboardCompetitionsRecentlyCompletedResponse {
    return GetLeaderboardCompetitionsRecentlyCompletedResponseToJSONTyped(json, false);
}

export function GetLeaderboardCompetitionsRecentlyCompletedResponseToJSONTyped(value?: GetLeaderboardCompetitionsRecentlyCompletedResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'leaderboards': ((value['leaderboards'] as Array<any>).map(LeaderboardCompetitionResponseToJSON)),
        'daysBack': value['daysBack'],
    };
}

